import { validate } from "../../helpers/validate.js";
import { guideCodeBlockHtml } from "./component.js";
import { attributesCodeBlockSchema } from "./attributes.js";
import { ScalarCodeBlockVue } from "./component.js";
import { parseCodeBlockMeta } from "./attributes.js";
import { hydrate } from "./hydration.js";
const scalarCodeBlock = {
  name: "scalar-code",
  tagName: "scalar-code",
  tiptapName: "custom_code_block",
  attributeTransform: (_, attrs) => {
    return validate(attributesCodeBlockSchema, {
      ...attrs,
      lang: attrs.lang || "plaintext"
    });
  },
  render: async (props) => {
    const transformed = scalarCodeBlock.attributeTransform("", props);
    return transformed ? guideCodeBlockHtml(transformed) : "";
  },
  hydrate
};
export {
  ScalarCodeBlockVue,
  parseCodeBlockMeta,
  scalarCodeBlock
};
//# sourceMappingURL=index.js.map
